"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AgeVerificationMode;
(function (AgeVerificationMode) {
    AgeVerificationMode["NONE"] = "none";
    AgeVerificationMode["MANUAL"] = "manual";
    AgeVerificationMode["SCAN"] = "scan";
})(AgeVerificationMode = exports.AgeVerificationMode || (exports.AgeVerificationMode = {}));
//# sourceMappingURL=Location.js.map